import Modal from '@mui/material/Modal';

import IconBtn from 'components/common/IconBtn';
import { ReactComponent as CrossSimpleIcon } from 'assets/icons/crossIcon.svg';
import styles from './PrimaryModal.module.scss';

type Props = {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    maxWidth?: string;
    width?: string;
    padding?: string;
    style?: React.CSSProperties;
    modalStyle?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
    modalWrapper?: string;
    hideCloseButton?: boolean;
};

const PrimaryModal = ({
    open,
    onClose,
    children,
    maxWidth = '900px',
    width = '100%',
    padding = '0 20px',
    style,
    modalStyle,
    modalWrapper,
    contentStyle,
    hideCloseButton = false,
}: Props) => {
    return (
        <Modal open={open} onClose={onClose} style={modalStyle}>
            <div
                className={modalWrapper || styles['modal-wrapper']}
                style={{
                    maxWidth: maxWidth,
                    width: width,
                    padding: padding,
                    ...style,
                }}
            >
                <div className={styles.modal} style={{ ...contentStyle }}>
                    {!hideCloseButton && (
                        <div className={styles['modal__btn-wrapper']}>
                            <IconBtn style={{ height: '30px', width: '30px' }} onClick={onClose}>
                                <CrossSimpleIcon className={styles['close-icon']} />
                            </IconBtn>
                        </div>
                    )}
                    {children}
                </div>
            </div>
        </Modal>
    );
};

export default PrimaryModal;
